(function () {
  if (window.acustomSiblingNavigationLoaded) return;
  window.acustomSiblingNavigationLoaded = true;
  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest("[data-sibling-link]");
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var swatches = link.closest("[data-sibling-options]");
      var form = link.closest("form");
      if (!swatches || !form) return;
      var records;
      try {
        records = JSON.parse(swatches.dataset.siblingOptions);
      } catch (_) {
        return;
      }
      var selected = form.querySelector('select[name="id"]');
      var current = records.find(function (v) {
        return String(v.id) === (selected && selected.value);
      });
      var index = Number(swatches.dataset.optionIndex);
      var color = link.closest("[data-value]").dataset.value;
      var target =
        current &&
        records.find(function (v) {
          return (
            v.options[index] === color &&
            v.options.every(function (value, i) {
              return i === index || value === current.options[i];
            })
          );
        });
      // Preserve the garment option. Without a matching target, keep the ordinary link.
      if (target && target.url) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(target.url);
      }
    },
    true,
  );
})();
